import { Fragment, useEffect } from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { TextKey, DataTestId, RouteName } from '@mews-commander/enums';
import { IconName } from '@optimus-web/core';
import { getSelectedServiceId } from '@mews-commander/legacy-entities/src/ducks/serviceSelect';
import DashboardTitle from '../components/DashboardTitle';
import DashboardTextLink from '../components/DashboardTextLink';
import { subscribeResourceUpdates, unsubscribeResourceUpdates } from '../../../core/websockets/eventHandlers/spaces';
import ResourceStatusChart from './ResourceStatusChart';

const ResourceStatusStatistics = ({ startPoller, stopPoller, selectedServiceId }: $TSFixMe) => {
    useEffect(() => {
        startPoller();
        return stopPoller;
    }, [startPoller, stopPoller]);
    return (
        <Fragment>
            <DashboardTitle testId={DataTestId.Resources} textKey={TextKey.ResourcePlural} />
            <DashboardTextLink
                textKey={TextKey.ResourceStatusReport}
                iconName={IconName.SpaceStatus}
                route={RouteName.ResourceStatusReportIndex}
                routeParams={{
                    query: {
                        'Service.Id': selectedServiceId,
                    },
                }}
            />
            <ResourceStatusChart dataTestId={DataTestId.ResourceStatusChart} />
        </Fragment>
    );
};

export default connect(
    createStructuredSelector({
        selectedServiceId: getSelectedServiceId,
    }),
    {
        startPoller: subscribeResourceUpdates,
        stopPoller: unsubscribeResourceUpdates,
    }
)(ResourceStatusStatistics);
